
import { useContent } from "@/hooks";
import { defineComponent } from "vue";
import { Container } from "@/components/layout";
import LanguageSwitch from "./LanguageSwitch.vue";

export default defineComponent({
  name: "Header",
  components: { Container, LanguageSwitch },
  setup() {
    const { links } = useContent();

    return { links };
  },
});
